<template>
  <v-alert
    border="top"
    color="orange"
    colored-border
    dense
    class="pa-0"
    :style="{ height: blockCardHeight + 'px', overflow: 'hidden'}"
  >
    <v-card-title class="d-flex flex-column justify-start align-start mt-2">
      <h3 class="subtitle-2 text-uppercase ml-2">
        <v-icon>mdi-account-outline</v-icon>
        ми на зв'язку
      </h3>
    </v-card-title>
    <v-divider class="ml-6 mr-6" />
    <v-card-text class="ml-2 mb-0">
      <p><b>Менеджер:</b> {{ managerName }}</p>
      <p class="mb-0">{{ managerEmail }}</p>
      <p class="mb-0">{{ supportEmail }}</p>
    </v-card-text>
  </v-alert>
</template>

<script>
export default {
  props: ["items"],
  data: () => ({
    tab: "",
    supportEmail: "support@tqm.com.ua",
  }),
  computed: {
    managerName() {
      return this.items.manager ? this.items.manager.title : null;
    },
    managerEmail() {
      return this.items.manager ? this.items.manager.email : null;
    },
    blockCardHeight() {
      return window.innerHeight * 0.27;
    },
  },
};
</script>